const Images = [
	'3637930189.jpg',
	'3087256266.jpg',
	'04616825.jpg',
	'394954-2448257816.jpg',
	'20250718_211056.jpg',
	'20250718_210754.jpg',
	'20250718_210543.jpg',
	'20250621_024515.jpg',
	'gettyimages-1790849617-1852195796.jpg',
	'gettyimages-2180359172-20241028114420057-397017851.jpg',
	'20250619_090102.jpg',
	'20250619_090059.jpg',
	'Gaza+Flottila+seized-3303380756.jpg',
	'47.webp',
	'02-Arwa-Gaza-oped-3160663336.jpg',
	'IMG_7250-780.jpeg',
	'27629170.jpg',
	'1989297323_2931697789.jpg',
	'GKFgwz.jpg',
	'001108.jpg',
	'kamal-adwan-hospital.jpeg',
	'israel-gaza-hamas-rafah-genocide-palestine-1536x1025.webp',
	'israel-gaza-hamas-rafah-genocide-palestine-1536x864.jpg',
	'298232.jpeg',
	'image1170x530cropped_1.jpg',
	'20.png',
	'23.png',
	'9.webp',
	'1719404557.jpg',
	'1.jpg',
	'22.png',
	'3.webp',
	'4.webp',
	'5.jpg',
	'6.png',
	'7.jpeg',
	'2.webp',
	'8.jpg',
	'10.webp',
	'11.webp',
	'12.webp',
	'13.webp',
	'14.webp',
	'15.webp',
	'16.webp',
	'17.webp',
	'18.webp',
	'21.png',
	'martyr_kids_gaza-2164397825.jpg',
	'Maghazi-massacre-24-December-2023.webp',
	'palestinian-man-grieves-child-killed-in-rafah-bombing.webp',
	'gaza-israel-genocide-palestine6-884x1536.webp',
	'image-1735315271.jpg',
	'02-Arwa-Gaza-oped-3160663336.jpg',
	'47.webp',
	'IMG_7250-780.jpeg',
];

export default Images;